import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Sponsor.css";
import AboutBanner from "../AboutBanner/AboutBanner";
import { trackEvent, trackPageView } from "../../utils/tracking";
// import board1 from '../../../images/board-1.png';

function Sponsor() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/AboutUs/Sponsor",
      "jmf_about-us_sponsor"
    );
    // trackPageView("http://localhost:710/AboutUs", "jmf_about-us");

    trackEvent({
      category: "Dynamic Page",
      action: "Sponsor Page Loaded",
      label: "jmf_about-us_sponsor",
      // value: 1,
    });
  }, []);

  const [pathname, setPathName] = useState("");
  useEffect(() => {
    const pathname = window.location.pathname;
    const lastSegment = pathname.slice(pathname.lastIndexOf("/") + 1);
    const CategoryIdUrlid = lastSegment;
    setPathName(CategoryIdUrlid);
  });
  return (
    <>
      <AboutBanner />
      <section className="trustee-sc sponsor-sc">
        <Container>
          <Row>
            <Col sm={12}>
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i class="fa fa-home" aria-hidden="true"></i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                <li>
                  <a href="/AboutUs">
                    <i>About Us</i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                {/* <li>Calculator</li><i class="fa fa-angle-right" aria-hidden="true"></i> */}
                {window.location.pathname != "/AboutUs" ? (
                  <li>{pathname}</li>
                ) : (
                  ""
                )}
              </ul>
              <div className="section-header">
                <h2>Sponsor</h2>
              </div>
            </Col>
            <Col sm={12}>
              <div className="about-common-left">
                <h5>JM Financial Limited</h5>
                <p>
                  7th Floor, Cnergy, Appasaheb Marathe Marg, Prabhadevi,Mumbai -
                  400 025.
                </p>
              </div>
              <div className="about-common-right">
                <p>
                  JM Financial Limited (JM Financial) is the Sole Sponsor of JM
                  Financial Mutual Fund. JM Financial is the flagship listed
                  company belonging to JM Financial Group and is currently a
                  holding company of JM Financial Asset Management Limited.
                  J.M.Financial and Investment Consultancy Services Private
                  Limited, the erstwhile sponsor of JM Financial Mutual Fund is
                  one of the promoters of JM Financial.
                </p>
                <p>
                  The Sponsor is not responsible or liable for any loss
                  resulting from the operation of the Scheme beyond the
                  contribution of an amount of Rupees one Lac made by it towards
                  the initial corpus for setting up the Fund and such other
                  accretions and additions to the corpus.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Sponsor;
